import { createClient } from '@supabase/supabase-js';

// These would typically be environment variables
// For now, using placeholders that need to be replaced with actual Supabase credentials
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Types for our discount codes table
export interface DiscountCode {
  id: string;
  code: string;
  discount_percentage: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

// Types for discount submissions (tracking usage)
export interface DiscountSubmission {
  id: string;
  discount_code: string;
  submitted_at: string;
  ip_address?: string;
}

// Types for contact form submissions
export interface ContactSubmission {
  id: string;
  name: string;
  email: string;
  phone?: string;
  experience_level: string;
  training_goals: string;
  preferred_schedule?: string;
  budget_range?: string;
  additional_info?: string;
  submitted_at: string;
}
